import {createReducer} from 'helpers';

export const ready = createReducer(false, {
  APP_LAUNCH: () => false,
  GOOGLE_API_LOADED: () => true,
});
